import LegacyInterceptor from '../LegacyInterceptor'

const api = new LegacyInterceptor()

export default {
  calculateProcedimentos(data: any): any {
    return api.post('/calculadora/calcula', data)
  },
}
